import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driverMessagingPreferencesAdapter = getAdapter({ idFieldName: 'value' });

const driverMessagingPreferencesSlice = createSlice({
  name: 'driverMessagingPreferences',
  initialState: driverMessagingPreferencesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setDriverMessagingPreferences: (state, { payload: { driverMessagingPreferences, source } }) => {
      driverMessagingPreferencesAdapter.setAll(state, driverMessagingPreferences);
      state.source = source;
    }
  }
});

const selectors = driverMessagingPreferencesAdapter.getSelectors(({ driverMessagingPreferences }) => driverMessagingPreferences);

export const getDriverMessagingPreferences = state => selectors.selectAll(state);

export const { setDriverMessagingPreferences } = driverMessagingPreferencesSlice.actions;

export default driverMessagingPreferencesSlice.reducer;
